import { graphql } from 'gatsby';
import React, { ReactElement } from 'react';
import Layout from '../components/Layout';
import * as styles from '../styles/project-details.module.css';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

interface Props {
  data: {
    markdownRemark: {
      html: string;
      frontmatter: {
        stack: string;
        title: string;
        featuredImg: FileNode;
      };
    };
  };
}

export default function ProjectDetails({ data }: Props): ReactElement {
  const { html } = data.markdownRemark;
  const { stack, title } = data.markdownRemark.frontmatter;
  const image = getImage(data.markdownRemark.frontmatter.featuredImg);
  console.log(image);
  return (
    <Layout>
      <div className={styles.details}>
        <h2>{title}</h2>
        <h3>{stack}</h3>
        <div className={styles.featured}>
          <GatsbyImage image={image!} alt="Banner" />
        </div>
        <div className={styles.html} dangerouslySetInnerHTML={{ __html: html }}></div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query ProjectDetails($slug: String) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        stack
        title
        featuredImg {
          childImageSharp {
            gatsbyImageData(width: 800, placeholder: BLURRED)
          }
        }
      }
    }
  }
`;
